<template>
	<section class="flex ">
		<div class="image mr-4">
			<img :src="campaign.author.image" alt="Profile" class="w-12 rounded" />
		</div>
		<div>
			<h5 class="mb-3"><strong> {{campaign.author.name}}</strong></h5>
			<div class="flex items-center">
				<feather-icon icon="ClockIcon" class="text-warning mr-3"></feather-icon>
				<span>3 hari yang lagi</span>
			</div>
		</div>
	</section>
</template>
<script>
export default {
  props: ['campaign']
}
</script>